import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@/lib/i18n/config';

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  ja: '日本語',
  en: 'English',
};

export const getLanguageLabel = (language: SupportedLanguage) =>
  LANGUAGE_LABELS[language];

export type LanguageOption = {
  value: SupportedLanguage;
  label: string;
};

export const getLanguageOptions = (): LanguageOption[] =>
  SUPPORTED_LANGUAGES.map((language) => ({
    value: language,
    label: getLanguageLabel(language),
  }));

export const findLanguageOption = (
  language: SupportedLanguage,
  options: LanguageOption[]
) => options.find((option) => option.value === language);
